module.exports = __webpack_public_path__ + "static/media/bravo.1da275b2.svg";